module.exports = vendors_af8df5bc1c8047ef7e40;